import i18n from "i18next";
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";

if (localStorage.getItem('i18nextLng') === null) {
  switch (process.env.REACT_APP_APP) {
    case 'tazama':
      localStorage.setItem('i18nextLng', 'fr')
      break;
    default:
      localStorage.setItem('i18nextLng', 'en')
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: "logger",

    log(args) {
      this.output('log', args);
    },

    warn(args) {
      this.output('warn', args);
    },

    error(args) {
      this.output('error', args);
    },

    output(type, args) {
      // console.log(type, args);
      // console.log(`"${args[4]}" : "${args[4]}"`);
    },
  })
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    load: "languageOnly",
    nsSeparator: ':::',
    keySeparator: '::'
  });